import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { CopyOutlined } from '@ant-design/icons';
import DropdownField from '@components/common/form/DropdownField';
import {
    DATE_FORMAT_DISPLAY,
    DATE_FORMAT_VALUE,
    DEFAULT_FORMAT,
    DeviceKinds,
} from '@constants';
import {
    orderconDeviceKinds,
    tabletOrderQrCodeTypes,
} from '@constants/masterData';
import useBasicForm from '@hooks/useBasicForm';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, DatePickerField, SelectField, TextField } from '@itz/react-cms-element';
import { copyToClipboard } from '@utils';
import { Card, Col, Row } from 'antd';
import dayjs from 'dayjs';

const DevicesForm = (props) => {
    const translate = useTranslate();
    const kinhValues = translate.formatKeys(orderconDeviceKinds, [ 'label' ]);
    const subKindValues = translate.formatKeys(tabletOrderQrCodeTypes, [ 'label' ]);
    const [ deviceKind, setDeviceKind ] = useState();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const restaurantId = queryParams.get('restaurantId');

    const { formId, actions, dataDetail, onSubmit, setIsChangedFormValues, branchs, isEditing } = props;
    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });


    const handleSubmit = (values) => {
        if (values.expireDate) {
            values.expireDate = dayjs(values.expireDate).format(DEFAULT_FORMAT);
        }
        const formattedValues = {
            ...values,
            restaurantId: restaurantId,
        };

        return mixinFuncs.handleSubmit(formattedValues);
    };

    useEffect(() => {
        dataDetail.expireDate = dataDetail.expireDate && dayjs(dataDetail.expireDate, DATE_FORMAT_VALUE);
        form.setFieldsValue({
            ...dataDetail,
            deviceName: dataDetail.deviceName,
            deviceToken: dataDetail.deviceToken,
            deviceKind: dataDetail.deviceKind,
        });
        setDeviceKind(dataDetail.deviceKind);
    }, [ dataDetail ]);
    return (
        <BaseForm id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            required
                            label={<FormattedMessage defaultMessage="Device Name" />}
                            name="deviceName"
                        />
                    </Col>
                    <Col span={12}>
                        <TextField
                            required
                            label={<FormattedMessage defaultMessage="Device Token" />}
                            name="deviceToken"
                        />
                    </Col>
                    {isEditing && (
                        <>
                            <Col span={12}>
                                <TextField
                                    required
                                    label={<FormattedMessage defaultMessage="Username" />}
                                    name="username"
                                    disabled={isEditing}
                                />
                            </Col>
                            <Col span={12}>
                                <TextField
                                    required
                                    label={<FormattedMessage defaultMessage="Queue name" />}
                                    name="queueName"
                                    disabled={isEditing}
                                />
                            </Col>
                            <Col span={12}>
                                <TextField
                                    required
                                    label={<FormattedMessage defaultMessage="Client ID" />}
                                    name="clientId"
                                    disabled={isEditing}
                                    addonAfter={
                                        <CopyOutlined
                                            style={{
                                                color: '#1677ff',
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(dataDetail?.clientId, translate);
                                            }}
                                        />
                                    }
                                />
                            </Col>
                            <Col span={12}>
                                <TextField
                                    required
                                    label={<FormattedMessage defaultMessage="Client secret" />}
                                    name="clientSecret"
                                    disabled={isEditing}
                                    addonAfter={
                                        <CopyOutlined
                                            style={{
                                                color: '#1677ff',
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(dataDetail?.clientSecret, translate);
                                            }}
                                        />
                                    }
                                />
                            </Col>
                            {/* {deviceKind === DeviceKinds.DEVICE_TYPE_POS && (
                                <>
                                    <Col span={12}>
                                        <TextField
                                            required
                                            label={<FormattedMessage defaultMessage="Api key" />}
                                            name="apiKey"
                                            readOnly={isEditing}
                                            addonAfter={
                                                <CopyOutlined
                                                    style={{
                                                        color: '#1677ff',
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        copyToClipboard(dataDetail?.apiKey, translate);
                                                    }}
                                                />
                                            }
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <TextField
                                            required
                                            label={<FormattedMessage defaultMessage="Secret key" />}
                                            name="secretKey"
                                            readOnly={isEditing}
                                            addonAfter={
                                                <CopyOutlined
                                                    style={{
                                                        color: '#1677ff',
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        copyToClipboard(dataDetail?.secretKey, translate);
                                                    }}
                                                />
                                            }
                                        />
                                    </Col>
                                </>
                            )} */}
                        </>
                    )}
                    <Col span={12}>
                        <SelectField
                            required
                            label={<FormattedMessage defaultMessage="Kind" />}
                            name="deviceKind"
                            options={kinhValues}
                            placeholder={<FormattedMessage defaultMessage="Kind" />}
                            disabled={isEditing}
                            onChange={(value) => {
                                setDeviceKind(value);
                            }}
                        />
                    </Col>
                    {/* {deviceKind === DeviceKinds.DEVICE_TYPE_POS && (
                        <Col span={12}>
                            <TextField
                                required
                                label={<FormattedMessage defaultMessage="Webhook URL" />}
                                name="webhookUrl"
                            />
                        </Col>
                    )} */}
                    {deviceKind === DeviceKinds.DEVICE_TYPE_ORDER_QRCODE || dataDetail?.deviceSubKind ? (
                        <Col span={12}>
                            <DropdownField
                                fieldName="deviceSubKind"
                                label={<FormattedMessage defaultMessage="Sub kind" />}
                                required
                                options={subKindValues}
                                disabled={isEditing}
                            />
                        </Col>
                    ) : null}
                    <Col span={12}>
                        <DatePickerField
                            name="expireDate"
                            label={<FormattedMessage defaultMessage="Expiration date" />}
                            format={DATE_FORMAT_DISPLAY}
                            style={{ width: '100%' }}
                            disabledDate={(current) => current && current.isBefore(dayjs().add(1, 'day'), 'day')}
                        />
                    </Col>
                </Row>
                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default DevicesForm;
